import {
  selectCloudAndCadAlignReference,
  selectModelClippingBoxEnabled,
} from "@/store/modes/cloud-cad-alignment-mode-selectors";
import {
  AlignmentReference,
  setModelClippingBoxEnabled,
} from "@/store/modes/cloud-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import {
  ClippingBoxIcon,
  ToolButton,
  ToolGroup,
  grey,
} from "@faro-lotv/flat-ui";
import { Toolbar, Tooltip } from "@mui/material";
import type { JSX } from "react";
import { ModelElevationTool } from "./model-elevation-tool";

/** @returns The set-elevation step overlay for 3D model part */
export function ModelElevationOverlay(): JSX.Element {
  const dispatch = useAppDispatch();

  const isClippingBoxEnabled = useAppSelector(selectModelClippingBoxEnabled);

  const reference = useAppSelector(selectCloudAndCadAlignReference);

  return (
    <>
      <Toolbar
        sx={{
          position: "absolute",
          right: reference === AlignmentReference.bimModel ? "0%" : "50%",
          top: "50%",
        }}
      >
        <ToolGroup>
          <Tooltip title="Clip 3D model" placement="left">
            <ToolButton
              sx={{ backgroundColor: grey[1000] }}
              selected={isClippingBoxEnabled}
              onClick={() => {
                dispatch(setModelClippingBoxEnabled(!isClippingBoxEnabled));
              }}
            >
              <ClippingBoxIcon sx={{ width: "24px", height: "24px" }} />
            </ToolButton>
          </Tooltip>
        </ToolGroup>
      </Toolbar>
      <ModelElevationTool />
    </>
  );
}
